export default __webpack_public_path__ + "static/media/panel-icon.2685d7f0.svg";